var $ = global.jQuery = global.$;
var parser = require('../lib/parser');
var velocity = require('velocity-animate');
var _Base = require('./_Base');

/**
 * Mobile navigation widget
 * @class
 * @extends _Base
 */
var MobileNav = _Base.extend(
  /** @lends MobileNav.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this,
      trigger = this.$el.find('[data-nav-toggle]'),
      close = this.$el.find('[data-nav-close]');

    this.container = this.$el.find('[data-nav-container]');
    this.isOpen = true;

    this.addMenus();
    this.close();

    function triggerClick(event) {
      event.preventDefault();
      self.open();
    }

    function closeClick(event) {
      event.preventDefault();
      self.close();
    }

    function documentClick(event) {
      if ($(event.target).closest(self.$el).length === 0) {
        self.close();
      }
    }

    trigger.on('click', triggerClick);
    close.on('click', closeClick);
    $(document).on('click', documentClick);
  },
  addMenus: function() {
    var $primaryNav = $('#PrimaryNav').clone().attr('id','PrimaryNavMobile');
    var $secondaryNav = $('#SecondaryNav').clone().attr('id','SecondaryNavMobile');

    var secondaryNav = $secondaryNav.html().replace(/SubNavItem|__Dummy/g,'MobileSubNavItem');

    $secondaryNav = $(secondaryNav);

    this.container.append($primaryNav);
    this.container.append($secondaryNav);

    parser.parse(this.container);
  },
  open: function() {
    var self = this;
    if (this.isOpen) return false;
    this.container.velocity({
      'translateX': '0%',
      'opacity': '1'
    }, {
      'display': 'block',
      duration: 300,
      complete: function() {
        var svg = self.container.find('svg').eq(0);
        var svgParent = svg.parents().eq(0);
        svg.detach();
        svgParent.append(svg);
        self.isOpen = true;
      }
    });
  },
  close: function(duration) {
    var self = this;
    if (!this.isOpen) return false;
    duration = duration || 300;
    this.container.velocity({
      'translateX': '100%'
    }, {
      'display': 'none',
      duration: duration,
      complete: function() {
        self.isOpen = false;
      }
    });
  },
  /**
   * Resize handler
   * @private
   */
  _resizeHandler: function() {
    if (utils.getWindow().width !== this.w){
      this.redraw();
    }
  }
});

module.exports = MobileNav;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/MobileNav.js
// module id = 10
// module chunks = 0